import React, { useRef } from 'react';
import _ from 'lodash';
import { useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import PdfScreeningForm from './PdfScreeningForm'
import html2pdf from 'html2pdf.js';

function ScreeningsSuccess() {
  const { state } = useLocation();
  const { data, signature, language, languages } = state;

  const printRef = useRef();

  const generatePDF = () => {
    const element = printRef.current;

    const opt = {
      margin: [0, 0, 15, 0],
      filename: 'screening.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'p' }
    };

    html2pdf().set(opt).from(element).save();
  };


  return (
    <div className="flex flex-col items-center p-8 text-center">
      <h2 className="text-2xl font-bold mb-4">
        <FormattedMessage id="/gx5bs" description="success" defaultMessage="Success!" />
      </h2>
      <p className="mb-6 text-gray-700">
        <FormattedMessage
          id="x9J1KD"
          description="screenings-social-needs"
          defaultMessage="We got your social needs screening."
        />
      </p>
      <div className="w-full max-w-md border border-solid rounded-md border-dark-border-blue p-6 mb-4 bg-dark-fill-blue shadow-md">
        <h2 className="text-xl font-bold mb-4">
          <FormattedMessage id="fB/+5s" description="screening-next-step" defaultMessage="Next Steps" />
        </h2>
        <p className="text-gray-800">
          <FormattedMessage
            id="3XEG9V"
            description="screening-success-message"
            defaultMessage="We're reviewing your responses and will reach out in the next few business days to discuss available services. If you have any questions or concerns before then, feel free to contact us."
          />
        </p>
      </div>
      <div className="flex justify-center mt-4">
        <button
          className="px-8 py-3 font-bold text-white bg-blue-900 shadow-md hover:bg-blue-800 transition duration-300"
          type="button"
          onClick={generatePDF}
        >
          <FormattedMessage id="3m2erL" description="downloadScreen" defaultMessage="Download Screening" />
        </button>
      </div>
      {/* Hidden Content for PDF */}
      <div hidden>
        <div ref={printRef}>
          <PdfScreeningForm
            data={data}
            signature={signature}
            language={language}
            languages={languages}
          />
        </div>
      </div>
    </div>
  );
}

export default ScreeningsSuccess;
